import * as React from "react";

import { cn } from "@/lib/utils";
import { EyeIcon, EyeOffIcon } from "lucide-react";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & { icon?: React.ReactNode }
>(({ className, type, icon, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === "password";

  const togglePasswordVisibility = (): void => {
    setShowPassword((previous) => !previous);
  };

  return (
    <div className="relative flex items-center">
      {icon && (
        <div
          className="absolute left-1 p-1 focus:outline-none text-grey-400"
          style={{
            width: "2.5rem",
            height: "2.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </div>
      )}
      <input
        ref={ref}
        type={isPassword ? (showPassword ? "text" : "password") : type}
        className={cn(
          "flex w-full rounded-md border-input px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-base focus:border-none",
          isPassword && "pr-11",
          icon && "pl-11",
          "text-grey-400 bg-tinted-grey-1 h-11 border border-tinted-grey-2",
          className
        )}
        {...props}
      />
      {isPassword && (
        <button
          className="absolute right-1 p-1 focus:outline-none text-grey-400"
          type="button"
          style={{
            width: "2.5rem",
            height: "2.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={togglePasswordVisibility}
        >
          {showPassword ? (
            <EyeOffIcon className="h-5 w-5" />
          ) : (
            <EyeIcon className="h-5 w-5" />
          )}
        </button>
      )}
    </div>
  );
});
Input.displayName = "Input";

export { Input };
